import { Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { languages } from "../common/Contants";

import "../common/Contants";
import AddDocumentDescription from "../components/addDocument_components/AddDocumentDescription";
import SelectDocument from "../components/addDocument_components/SelectDocumentType";
import UploadFile from "../components/addDocument_components/UploadFile";
import Comment from "../components/generic_components/Comment";
import Reason from "../components/generic_components/Reason";
import NextButton from "../components/addDocument_components/NextButton";
import { ClearButton } from "../components/generic_components/ClearButton";
import { ComponentStruct } from "../common/Interfaces";
import SelectLanguages from "../components/generic_components/SelectLanguages";
import ErrorMessage from "../components/generic_components/ErrorMessage";

export default function AddDocument() {
  const location = useLocation();
  const hide: boolean = process.env.REACT_APP_HIDE === "true";
  const addDocumentState = location.state?.addDocumentState;
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const [selectedType, setSelectedType] = useState<ComponentStruct>({
    key: "",
    label: "deselect",
  });
  const [selectedDescription, setSelectedDescription] =
    useState<ComponentStruct | null>(null);
  const [selectedLanguages, setSelectedLanguages] = useState<string[]>(
    languages.map((lang) => lang.key)
  );
  const [selectedComment, setSelectedComment] = useState("");
  const [selectedReason, setSelecetedReason] = useState<string | null>(null);

  const [selectedUrl, setSelectedUrl] = useState("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [selectedRadio, setSelectedRadio] = useState("");
  const [clear, setClear] = useState(false);

  return (
    <>
      <AddDocumentDescription addDocumentState={addDocumentState} />
      <Row className="padding-top">
        <h4>Add Document</h4>
      </Row>
      {errorMessages.length > 0 && <ErrorMessage errors={errorMessages} />}
      <SelectDocument
        clear={clear}
        onChange={(type, description) => {
          setSelectedDescription(description);
          setSelectedType(type);
        }}
      />
      <SelectLanguages
        allLanguages={true}
        clear={clear}
        onChange={(selected) => setSelectedLanguages(selected)}
      />
      <UploadFile
        clear={clear}
        onChange={(url, file, radio) => {
          setSelectedUrl(url);
          setSelectedFile(file);
          setSelectedRadio(radio);
        }}
      />

      <Comment
        clear={clear}
        onChange={(comment: string) => setSelectedComment(comment)}
      />
      {!hide && (
        <Reason
          clear={clear}
          onChange={(reason: string | null) => setSelecetedReason(reason)}
        />
      )}

      <Row>
        <Col className="d-flex justify-content-end">
          <ClearButton clear={clear} onClear={setClear} />
          <NextButton
            addDocumentState={addDocumentState}
            selectedType={selectedType}
            selectedDescription={selectedDescription}
            selectedLanguages={selectedLanguages}
            selectedUrl={selectedUrl}
            selectedFile={selectedFile}
            selectedRadio={selectedRadio}
            selectedReason={selectedReason}
            selectedComment={selectedComment}
            onErrorMessages={setErrorMessages}
          />
        </Col>
      </Row>
    </>
  );
}
